module.exports = __webpack_public_path__ + "img/cta_image.83599f00.png";